import EncodedText from '@UI/encodedText/EncodedText';
import type { RootState } from '@generalTypes/rootStateTypes';
import { getAngularService } from '@kathondvla/react-shared-components/src/helpers/angularReactHelper';
import { selectExternalGoalOrItem } from '@newStore/llinkid/llinkidSelectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import './asideLlinkidGoal.scss';
import type { ContentHref, ContentRelation, ContentRelationType } from '@generalTypes/apiTypes';

const AsideLlinkidGoal: React.FC<{
  item: ContentRelation;
  options: { relationTypes: ContentRelationType[] };
  href: ContentHref;
}> = ({ item, options, href }) => {
  const $translate = getAngularService('$translate');
  const [isLoading, setIsLoading] = useState(true);

  const goal = useSelector((state: RootState) => selectExternalGoalOrItem(state, href));

  const multipleRelationTypes = options.relationTypes.length > 1;

  useEffect(() => {
    if (goal) {
      setIsLoading(false);
    }
  }, [goal]);
  const loadingClass = isLoading ? 'loadingSlider' : '';

  return (
    <>
      <div className={`col-md-2 indented ${loadingClass}`}>
        <EncodedText>{goal?.identifier}</EncodedText>
      </div>
      {multipleRelationTypes && (
        <div className={`col-md-2 indented ${loadingClass}`}>
          {$translate.instant(`relationType.${item.relationtype}`)}
        </div>
      )}
      <div className={`col-md-${multipleRelationTypes ? '7' : '9'} indented ${loadingClass}`}>
        <span
          dangerouslySetInnerHTML={{
            __html: goal?.descriptionText,
          }}
        />
      </div>
      <div className={`col-md-1 indented ${loadingClass}`}>
        {goal?.version &&
          $translate.instant('components.llinkid.goalRelations.fromVersion', {
            version: goal.version,
          })}
      </div>
    </>
  );
};

export default AsideLlinkidGoal;
